export const checkDateLessDays = (date: number | string | Date, daysCount = 3): boolean => {
  const daysInMs = daysCount * 24 * 60 * 60 * 1000
  const diff = new Date(date).getTime() - new Date().getTime()
  return diff > 0 && diff <= daysInMs
}
